import type { orderedQuestion } from "@/stores/gae/store_dynform"
import type { DynformEntryPOST } from "types/api/dynform"
import type { DynformAnswerDTO } from "types/api/dynform"
import { useCookies } from "@/composable/cookies"

const cookies = useCookies();

// Local `YYYY-MM-DD`: toISOString() would convert to UTC and could fall on the day before.
function toDateString(date: Date): string {
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    return `${date.getFullYear()}-${month}-${day}`
}

export function getContract(form: Map<number, orderedQuestion[]>, intervention_id: number, group: number, category_id: number, step: number, uuid?: string): DynformEntryPOST {
    const contract: DynformEntryPOST = {
        step,
        uuid: uuid ?? cookies.getCookieValue('user_uuid').value ?? undefined,
        group_id: group,
        category_id: category_id,
        intervention_id: intervention_id,
        isConsultant: false,
        answers: [] as DynformAnswerDTO[]
    }
    for (const [_, questions] of form)
        for (const question of questions) {
            if (question.step !== step) continue
            if (question.answer === null) continue
            if (question.answer === "") {
                continue
            }
            //if signature already sent
            if (question.type === 6 && question.answer.startsWith('signature-')) {
                continue
            }
            const value = question.answer instanceof Date ? toDateString(question.answer) : question.answer.toString()
            contract.answers.push({ question_id: question.id, value, media: null })
            contract.step = question.step
        }
    return contract
}